// src/components/NavDots.js
import React from "react";

const NavDots = ({ totalPages, currentPage, goToPage }) => {
  return (
    <div className="nav-dots">
      {[...Array(totalPages)].map((_, index) => (
        <div
          key={index}
          className={`nav-dot ${currentPage === index ? "active" : ""}`}
          onClick={() => goToPage(index)}
        />
      ))}
    </div>
  );
};

export default NavDots;
